import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { FaqsService } from '../faqs-service/faqs.service';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, finalize, map, tap } from 'rxjs';
import { QuestionItem } from 'src/app/shared/models/questionItem';
import { PUBLIC_PRIVATE_MODEL } from 'src/app/shared/constants/loggedinUser';
import { ShellService } from 'src/app/shell/shell.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionInfoResolver implements Resolve<QuestionItem> {
  constructor(
    private faqsService: FaqsService,
    private router: Router,
    private shellService: ShellService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionItem> {
    this.shellService.setIsLoading(true);

    const name = route.params['name'];
    const parentName = route.params['parentName'];

    return this.faqsService.getQuestionByName(parentName, name).pipe(
      tap(item => {
        const modelValue = this.faqsService.isAuthenticated
          ? PUBLIC_PRIVATE_MODEL.USER_LOGGED_IN
          : PUBLIC_PRIVATE_MODEL.USER_NOT_LOGGED_IN;

        if (
          item.publicPrivateModel !== null &&
          !item.publicPrivateModel?.includes(modelValue)
        ) {
          this.router.navigate(['']);
        }
      }),
      map(item => {
        item.showChat =
          this.faqsService.isAuthenticated &&
          !!item.vertical &&
          !!item.initialChatMessage
            ? item.showChat
            : false;
        return item;
      }),
      catchError((error: any) => {
        this.router.navigate(['']);
        return EMPTY;
      }),
      finalize(() => this.shellService.setIsLoading(false)),
    );
  }
}
